import {parseJSON, splitFullName} from "@fennecstudio/utils";

export function canEditEntry(session: any, family: any) {
	if (isAdmin(session)) return true;
	if (!session?.email || !family) return false;
	let emails = family.parents?.map((p: any) => p.email?.toLowerCase());
	emails.push(family.createdBy?.toLowerCase());
	emails = emails.filter(Boolean)
	return emails.includes(session?.email.toLowerCase());
}

export function getMimeType(file: any, fallback = null) {
	const byteArray = (new Uint8Array(file)).subarray(0, 4);
	let header = '';
	for (let i = 0; i < byteArray.length; i++) {
		header += byteArray[i].toString(16);
	}
	switch (header) {
		case "89504e47":
			return "image/png";
		case "47494638":
			return "image/gif";
		case "ffd8ffe0":
		case "ffd8ffe1":
		case "ffd8ffe2":
		case "ffd8ffe3":
		case "ffd8ffe8":
			return "image/jpeg";
		default:
			return fallback;
	}
}

export function getSession() {
	return parseJSON(localStorage.getItem('session') || '{}');
}

export function getSessionEmail() {
	return getSession()?.email;
}

export function isAdmin(session: any) {
	return session?.role === 'admin';
}

export function scrollToTop() {
	window.scrollTo({top: 0, behavior: 'smooth'});
}

export async function uploadToS3(blob: Blob, signedUrl: string, onProgress?: Function) {
	return new Promise(async (resolve, reject) => {
		try {
			const response = await fetch(signedUrl, {
				method: 'PUT',
				body: blob,
				headers: {
					'Content-Type': blob.type,
				},
				//@ts-ignore
				onUploadProgress: (progressEvent: any): void => {
					if (progressEvent.lengthComputable) {
						let uploadProgress = (progressEvent.loaded / progressEvent.total) * 100;
						if (onProgress) onProgress(uploadProgress);
					}
				}
			});

			if (!response.ok) reject('Upload failed');
			else resolve(undefined);

		} catch (error) {
			reject(error);
		}
	});
}

export function joinWithAnd(array: string[]) {

	if (!array || !array.length) return '';

	if (array.length === 1) return array[0];

	const lastItem = array.pop();

	return array.join(', ') + ' and ' + lastItem;
}

export function createVCard(person: any) {

	let vcard = {...person}
	if (vcard.name && (!vcard.firstName || !vcard.lastName)) {
		let {firstName, lastName} = splitFullName(vcard.name);
		vcard.lastName = lastName;
		vcard.firstName = firstName;
	}

	let photo:string  = '';
	// if (person.pictureUrl) {
	// 	let base64 = await fetchImageAsBase64(person.pictureUrl);
	// 	photo = `PHOTO;ENCODING=b;TYPE=JPEG:${base64.toString()}`
	// }

	return `
BEGIN:VCARD
VERSION:3.0
N:${vcard.lastName};${vcard.firstName}
FN:${vcard.name}
EMAIL:${vcard.email}
TEL:${vcard.phoneNumber}
TITLE:${vcard.name}
${photo}
END:VCARD
    `.trim();
}

async function fetchImageAsBase64(url: string): Promise<string> {
	const response = await fetch(url);
	const blob = await response.blob();
	return new Promise<string>((resolve, reject) => {
		const reader = new FileReader();
		reader.onloadend = () => resolve(reader.result as string);
		reader.onerror = error => reject(error);
		reader.readAsDataURL(blob);
	});
}

export function downloadVCard(person: any, filename: string = 'contact.vcf') {
	const vCardData = createVCard(person);
	console.log(vCardData);
	const blob: Blob = new Blob([vCardData], {type: 'text/vcard'});
	const url: string = URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = url;
	a.download = filename;
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
	URL.revokeObjectURL(url);
}